<template>
  <div class="mainCon">
    <div class="scene-Header">
      <div class="mainDivWidth flexDiv">
        <p class="sceneTitle">数字娱乐场景介绍</p>
        <p>集发行推广、游戏运营和营销服务为一体的线上综合平台</p>
        <div class="bussinbtn" @click="goBusiness()">立即对接</div>
      </div>
    </div>
    <div class="box-shadow">
      <div class="mainDivWidth flexDiv anchorNavList" id="anchorNavList">
        <p
          v-for="(nl, index) in navList"
          :key="index"
          :class="anchorId == index ? 'nowAnchor' : ''"
          @click="changeanchorId(index, nl.id)"
        >
          {{ nl.text }}
        </p>
      </div>
    </div>
    <!-- 场景现状 -->
    <section class="first-introduce flexDiv mainDivWidth">
      <div class="introduceTextImg">
        <img
          src="static/img/sceneImg/scene4-digital/firstImg.png"
          class="introduceImg"
        />
      </div>
      <div class="first-introduceText">
        <div class="introduceText-Title flexDiv">
          <p class="titleBg">场景现状</p>
          <p class="subheading">Scene introduction</p>
        </div>
        <div class="cer-FunCon">
          <p>
            截止目前已经与100家以上国内移动游戏厂商建立合作关系，平台已上线260余款移动游戏，60万以上注册用户，合作厂商、用户数量和移动游戏数量还在不断增加。
          </p>
        </div>
      </div>
    </section>
    <!-- 中心功能 -->
    <section class="centralFunction" id="centralFunction">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">中心功能</h3>
        <p class="advantageText smallRadius pointer">
          数字娱乐结算与推广服务中心，汇集各商业银行、数字娱乐厂商、推广渠道、内容渠道等多方优势资源，为数字娱乐企业提供内容分发、
          游戏发行与推广、游戏运营和数据营销等服务，并依托平台优势打造金融与游戏的异业合作桥梁。
        </p>
      </div>
    </section>
    <!-- 中心优势 -->
    <section id="centraladvantage">
      <div class="mainDivWidth">
        <h3 class="sectionTitle">中心优势</h3>
        <table class="centerAdvantageTable">
          <tr class="flexDiv">
            <td v-for="(cl, index) in centerFunList" :key="index">
              <div class="center-normalCon flexDiv">
                <img :src="cl.img" />
                <p v-text="cl.normalBtn"></p>
              </div>
              <div class="center-hoverCon flexDiv">
                <p v-text="cl.hoverText" class="smallText"></p>
                <p v-text="cl.hoverBtn"></p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </section>
    <!-- 合作模式 -->
    <section class="CO-OP" id="CO-OP">
      <div class="mainDivWidth">
        <h3 class="sectionTitle whiteText">合作模式</h3>
        <div class="scene4-coop flexDiv">
          <div
            class="coopContent flexDiv"
            v-for="(cl, index) in coopList"
            :key="index"
          >
            <img src="static/img/start.png" />{{ cl.text }}
          </div>
        </div>
      </div>
    </section>
    <!-- 游戏入驻 -->
    <section id="gameIn">
      <h3 class="sectionTitle">游戏入驻</h3>
      <div class="mainDivWidth smallRadius joinUpFlow h5-joinUpFlow">
        <p class="flowTitle flowTitle-bg01" id="joinUpFlow">
          游戏开发/发行商入驻平台
        </p>
        <div class="definite-flow flow-sevenStep flexDiv">
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn01.png"
                class="allImgW"
              />
            </div>
            <p>注册成为数字娱乐开发/发行者</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn02.png"
                class="allImgW"
              />
            </div>
            <p>上传公司资质</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn03.png"
                class="allImgW"
              />
            </div>
            <p>上传游戏资质</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn04.png"
                class="allImgW"
              />
            </div>
            <p>对接数字娱乐SDK</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn05.png"
                class="allImgW"
              />
            </div>
            <p>游戏测试</p>
          </div>
          <p></p>
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn06.png"
                class="allImgW"
              />
            </div>
            <p>上线</p>
          </div>
          <p class="hidden-xs"></p>
          <img
            src="static/img/sceneImg/xs-next.png"
            class="visible-xs xs-nextImg"
          />
          <div class="pointer hoverBlueText">
            <div class="circleradius imgDivBg">
              <img
                src="static/img/sceneImg/scene4-digital/gameIn07.png"
                class="allImgW"
              />
            </div>
            <p>门户推广、活动推广</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "sceneDigital",
  data: function() {
    return {
      anchorId: 0,
      navList: [
        { text: "中心功能", id: "centralFunction" },
        { text: "中心优势", id: "centraladvantage" },
        { text: "合作模式", id: "CO-OP" },
        { text: "游戏入驻", id: "gameIn" }
      ],
      centerFunList: [
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon01.png",
          normalBtn: "免费",
          hoverText: "实现免费、快速搭建数字娱乐+金融生态平台",
          hoverBtn: "免费"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon02.png",
          normalBtn: "场景丰富",
          hoverText: "融合游戏、视频充值、权益购买等数娱娱乐场景，合作方无需投入场景建设资源",
          hoverBtn: "场景丰富"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon03.png",
          normalBtn: "促销",
          hoverText: "实现金融+线上数字娱乐场景的融合，有效促进客户活跃与留存",
          hoverBtn: "促销"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon04.png",
          normalBtn: "专业运营",
          hoverText: "佰付美提供包括各类活动策划、裂变营销等专业线上产品和运营支持",
          hoverBtn: "专业运营"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon05.png",
          normalBtn: "灵活配置",
          hoverText: "灵活方便，可根据合作方要求调整场景或产品配置",
          hoverBtn: "灵活配置"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon06.png",
          normalBtn: "随时部署",
          hoverText: "无需开发，H5随时部署",
          hoverBtn: "随时部署"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon07.png",
          normalBtn: "全面支持",
          hoverText: "支持伙伴获客活跃留存活动开展，引入更多金融营销资源",
          hoverBtn: "全面支持"
        },
        {
          img: "static/img/sceneImg/scene4-digital/centerAdvIcon08.png",
          normalBtn: "年轻用户群",
          hoverText: "通过各类热门游戏及独家的营销活动，吸引更多的新用户、年轻化用户下载",
          hoverBtn: "年轻用户群"
        }
      ],
      coopList: [
        { text: "线上场景拓展合作" },
        { text: "营销合作" },
        { text: "用户推广合作" },
        { text: "定制游戏合作" },
        { text: "品牌营销异业合作" },
        { text: "支付合作" }
      ],
      idconts:"",
    };
  },
  created(){
    this.idconts = this.getQueryString('idcont');
  },
  mounted() {
    $("html, body").animate({ scrollTop: "0" }, 0);
    if(this.idconts){
      $(".mainCon").css('margin-top','0')
      $("#nava").css('display','none')
      $(".scene-Header").css('display','none')
      $(".servebanner").css('display','none')
      $(".footer").css('display','none')
    }
  },
  methods: {
    goBusiness(){
      this.$router.push({"path": "/cooperate"})
    },
    changeanchorId(num, id) {
      this.anchorId = num;
      $("html, body").animate({ scrollTop: $("#" + id).offset().top }, 1000);
      return false; // 返回false可以避免在原链接后加上#
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return r[2]; return null;
    },
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/sceneCss/sceneStyle";
@import "../../assets/css/sceneCss/sceneFour";
</style>



// WEBPACK FOOTER //
// src/pages/scenePage/scene4-digital.vue